import React, { createContext, useContext } from "react"

export interface ThemeLayoutSubmoduleDirtyContextValue {
  setSubmoduleDirty: (key: string, dirty: boolean) => void
}

const ThemeLayoutSubmoduleDirtyContext = createContext<ThemeLayoutSubmoduleDirtyContextValue | null>(null)

export const ThemeLayoutSubmoduleDirtyProvider = ThemeLayoutSubmoduleDirtyContext.Provider

export const useThemeLayoutSubmoduleDirty = (): ThemeLayoutSubmoduleDirtyContextValue => {
  const value = useContext(ThemeLayoutSubmoduleDirtyContext)

  if (!value) {
    throw new Error("useThemeLayoutSubmoduleDirty must be used within ThemeLayoutSubmoduleDirtyProvider")
  }

  return value
}
